import { useEffect, useRef } from 'react';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

/**
 * Auto-scrolls to GR Management section when returning from document preview
 * Project selection is handled by URL's project_id parameter in handleProjectDataLoaded
 * Scroll indicator is stored in sessionStorage (like Portfolio Overview)
 */
export default function useGRManagementAutoScroll(
  grManagementRef: React.RefObject<HTMLDivElement>,
  loading: boolean
) {
  const hasScrolled = useRef(false);

  useEffect(() => {
    // Only scroll once and when data is loaded
    if (hasScrolled.current || loading) {
      return;
    }

    // Check sessionStorage for scroll indicator
    const shouldScroll = storage.getSessionStorageItem(
      STRATEGIC_STORAGE_KEY.INDEV_GR_MANAGEMENT_ID
    );

    if (shouldScroll) {
      // Wait for project data to load, then scroll to GR Management
      setTimeout(() => {
        if (grManagementRef.current) {
          grManagementRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          hasScrolled.current = true;
        }
        
        // Clear the indicator after scrolling
        storage.removeSessionStorageItem(STRATEGIC_STORAGE_KEY.INDEV_GR_MANAGEMENT_ID);
      }, 800); // Delay to allow project data to load after URL-based selection
    }

  }, [grManagementRef, loading]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      storage.removeSessionStorageItem(STRATEGIC_STORAGE_KEY.INDEV_GR_MANAGEMENT_ID);
    };
  }, []);
}

